/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SdkConfigModel } from '../../models/sdk-config-model';

export interface SessionSdkConfigGet$Params {

/**
 * The optional system identifier ID
 */
  systemIdentifierId?: string;
}

export function sessionSdkConfigGet(http: HttpClient, rootUrl: string, params?: SessionSdkConfigGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<SdkConfigModel>> {
  const rb = new RequestBuilder(rootUrl, sessionSdkConfigGet.PATH, 'get');
  if (params) {
    rb.query('systemIdentifierId', params.systemIdentifierId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<SdkConfigModel>;
    })
  );
}

sessionSdkConfigGet.PATH = '/Session/SDKConfig';
